import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'UserTypeSearch',
})
export class UserTypeSearchPipe implements PipeTransform {
  constructor() {}

  transform(items: Array<any>, userType: string, reportType: string): Array<any> {
    if (items && userType) {
      let result;
      if (userType == '신고자 전체') {
        result = items;
      }
      if (userType != '신고자 전체') {
        if (userType === '일반 회원') {
          result = items.filter(member => !member.userId.ownerSwitch);
        } else {
          result = items.filter(member => member.userId.ownerSwitch);
        }
      }

      let result2;
      if (reportType === '신고 구분 전체') {
        result2 = result;
      } else {
        if (reportType === '리뷰') {
          result2 = result.filter(report => report.type === 'review');
        } else {
          result2 = result.filter(report => report.type === 'owner');
        }
      }

      return result2;
    }
  }
}
